import _extends from "@babel/runtime/helpers/extends";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withEDSContext } from '../../EDSContext/EDSContext';
import DrawerWrapper from '../../DrawerWrapper/DrawerWrapper';
import Typography from '../../Typography/Typography';
import { default as withStyles } from '../../styles';
import { spacing40 } from '../../styles/tokens';
import isNil from 'lodash/isNil';
export var styles = function styles(theme) {
  return {
    root: {
      display: 'inline-block'
    },
    popperText: {
      marginBottom: spacing40
    },
    content: {
      paddingLeft: spacing40,
      paddingRight: spacing40
    },
    textContent: {
      paddingTop: spacing40
    }
  };
};
/**
 * `MobilePopper` to be rendered only on mobile platforms.
 */

var MobilePopper = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(MobilePopper, _React$Component);

  function MobilePopper() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MobilePopper.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (!this.props.onClose) {
      console.log('onClose is required for the mobile variant of Popper');
    }
  };

  _proto.render = function render() {
    var _classNames, _classNames2;

    var _this$props = this.props,
        classes = _this$props.classes,
        id = _this$props.id,
        className = _this$props.className,
        children = _this$props.children,
        TitleTypographyProps = _this$props.TitleTypographyProps,
        TextTypographyProps = _this$props.TextTypographyProps,
        PaperProps = _this$props.PaperProps,
        open = _this$props.open,
        DrawerProps = _this$props.DrawerProps,
        onClose = _this$props.onClose,
        text = _this$props.text,
        title = _this$props.title;
    var popperText = classes.popperText,
        textContent = classes.textContent;
    return /*#__PURE__*/React.createElement("div", {
      className: className
    }, /*#__PURE__*/React.createElement(DrawerWrapper, {
      title: title,
      id: id,
      PaperProps: PaperProps,
      DrawerProps: DrawerProps,
      open: open,
      handleClose: onClose,
      TitleTypographyProps: TitleTypographyProps
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames(classes.content, (_classNames = {}, _classNames[textContent] = !isNil(title), _classNames))
    }, text && /*#__PURE__*/React.createElement(Typography, _extends({
      gutterBottom: true,
      className: classNames((_classNames2 = {}, _classNames2[popperText] = children !== undefined, _classNames2))
    }, TextTypographyProps), text), children)));
  };

  return MobilePopper;
}(React.Component);

MobilePopper.propTypes = {
  /**
   * @ignore
   *
   * Classes used to extend original style object.
   */
  classes: PropTypes.object,

  /**
   * A CSS class that will be applied to the parent `div`.
   */
  className: PropTypes.string,

  /**
   * The contents of the popper.
   */
  children: PropTypes.node,

  /**
   * Props provided to the text `Typography` component
   */
  TextTypographyProps: PropTypes.object,

  /**
   * Props provided to the title `Typography` component
   */
  TitleTypographyProps: PropTypes.object,

  /**
   * The id is applied to the top level of the mobile popper
   */
  id: PropTypes.string,

  /**
   * Props applied to the `Paper` component
  */
  PaperProps: PropTypes.object,

  /**
   * Set to `true` to make the the popper visible.
   */
  open: PropTypes.bool.isRequired,

  /**
   * The text of the popper
   */
  text: PropTypes.string,

  /**
   * Title of the poppper
   */
  title: PropTypes.string,

  /**
   * Fires when the Popper closes.
   */
  onClose: PropTypes.func,

  /**
   * Props applied to the `Drawer` element.
   */
  DrawerProps: PropTypes.object
};
MobilePopper.defaultProps = {
  initialOpenOverride: false
};
export default withEDSContext(withStyles(styles)(MobilePopper));